// @flow
import trackRegisterAction from 'app/common/lib/util/trackRegisterAction';
import urlUtil from 'app/common/lib/urlUtil';

/**
 * Change the window location.
 * TODO (jeremy): this isn't being used on mobile but will potentially try to
 *     open a new window if it ever is. Need a better solution but this belongs
 *     in common/ instead of desktop/ so I'm moving it for now.
 *
 * This makes our code easier to test. If you have an action that should change
 * the location of the window, use this function instead of setting
 * `window.location`. You can spy on this function, but you cannot spy on
 * changing location.
 *
 * @param {string} url The url to go to.
 * @param {boolean=} external Open in a new window?
 * @return {Window}
 */

export default function changeWindowLocation(url: string, external?: boolean) {
  if (!__SERVER__) {
    let isSafariPrivateBrowsing;
    try {
      // Safari private browsing doesn't let you write to localStorage
      window.localStorage.test = 2;
      isSafariPrivateBrowsing = false;
    } catch (e) {
      isSafariPrivateBrowsing = true;
    }
    if (external && !isSafariPrivateBrowsing) {
      // Prevent dangerous open redirects
      const newWindow = window.open(url, '_blank');
      if (newWindow) {
        newWindow.opener = null;
      }
      return newWindow;
    } else {
      // Due to a browser bug in IE11/Edge do not use relative urls here
      url = urlUtil.absolutify(url);
      // Wrapped in a timeout to avoid infinitely making calls to `trackRegisterAction`
      setTimeout(() => {
        trackRegisterAction('setting_new_window_location');
      }, 0);
      window.location.href = url;
      return window;
    }
  }
  return undefined;
}
